module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 9
// module chunks = 0